<template>
  <section class="section blog" id="blog" aria-label="blog">
    <div class="container">
      <p class="section-subtitle text-center">Our Blog</p>

      <h2 class="h2 section-title text-center">Latest Blog & News</h2>

      <ul class="blog-list">
        <li v-for="(blog, index) in blogs" :key="index">
          <div class="blog-card">
            <figure
              class="card-banner img-holder"
              style="--width: 1180; --height: 800"
            >
              <img
                :src="blog.image"
                width="1180"
                height="800"
                loading="lazy"
                :alt="blog.title"
                class="img-cover"
              />

              <div class="card-badge">
                <ion-icon name="calendar-outline"></ion-icon>

                <time class="time" :datetime="blog.date">{{ blog.date }}</time>
              </div>
            </figure>

            <div class="card-content">
              <h3 class="h3">
                <a href="#" class="card-title">{{ blog.title }}</a>
              </h3>

              <p class="card-text">
                {{ blog.description }}
              </p>

              <a href="#" class="card-link">Read More</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    blogs() {
      // Use the services data from Vuex store
      return this.$store.getters["getBlogs"];
    },
  },
  mounted() {
    // Fetch services data from the API using Vuex action
    this.$store.dispatch("fetchBlogs");
  },
};
</script>
